export default __webpack_public_path__ + "static/media/emptyPrevious.cf275a6a.svg";